<!--<div style ="border-radius: 5px;border: 1px solid #D9D9D9;padding: 42px 42px;margin: 20px 0px;padding-bottom: 0px;"  id="statement-of-combined-income-preview">-->
<!--</div>-->


<div id="eng_dynamicHeight" appSpin [spinnerConfig]='spinnerConfig()' class="position-relative" [ngClass]="{'workbook-preview': placeOfPreview === 'Workbook', 'eng-preview page A4' : placeOfPreview !== 'Workbook' }">

</div>

